import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './core/auth/AuthProvider';
import App from './app/App';
import './styles/tokens.css';
import './styles/global.css';
import './styles/login-registration.css';
import { registerServiceWorker } from './core/pwa/registerServiceWorker';

// Le service worker est nécessaire aux notifications, y compris pendant les tests sur localhost.
registerServiceWorker();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
